import { useState } from "react";
import type { TimelinePerson } from "./activityTimelinePeople.lib";

const NO_PEOPLE: readonly TimelinePerson[] = [];

/**
 * The people to chart one by one over rows that may be placeholders kept
 * from an earlier Updated by. Rows don't say whom they were counted for, so
 * this remembers the ids of the people behind the last fresh rows and charts
 * `people` only when those cover every one of them; else none, which keeps
 * People drawn until fresh rows land.
 */
export function useChartedPeople({
    people,
    isPlaceholderData,
}: {
    people: readonly TimelinePerson[];
    isPlaceholderData: boolean;
}): readonly TimelinePerson[] {
    const ids = people.map(({ id }) => id);
    const [countedIds, setCountedIds] = useState<readonly number[]>([]);
    if (!isPlaceholderData && ids.join() !== countedIds.join()) {
        setCountedIds(ids);
    }
    return ids.every((id) => countedIds.includes(id)) ? people : NO_PEOPLE;
}
